import server from '@/request';

export default {
  getDistrictListByPid ({pid, excludeCountry = false}) {
    return server.post('/xiaozi-xmb/wireless/saas/district/getDistrictListByPid', {pid: pid, onlyFindCountryProvinceFlag: excludeCountry});
  },
};
